import React, { createContext, useCallback, useContext, useState } from 'react';

// Defaults — subtle entrance. Production-safe (panel nezobrazený = default values použité).
export const MOTION_DEFAULTS = {
  animIn: 'slideUp',           // fade | slideUp | slideLeft | slideRight | scale | blur
  duration: 600,               // ms
  stagger: 80,                 // ms — delay medzi po sebe id-úcimi prvkami (index * stagger)
  distance: 24,                // px — vzdialenosť slideUp/Down/Left/Right (0 = no movement)
  easing: 'ease-emphasized',   // ease | ease-emphasized | linear | bounce | elastic
  group: 'all',                // all | header | section | cards | pinned | invoices
};

const MotionCtx = createContext(null);

export function MotionProvider({ children }) {
  const [config, setConfig] = useState(MOTION_DEFAULTS);
  const [replayKey, setReplayKey] = useState(0);

  const update = useCallback((key, value) => {
    setConfig((c) => ({ ...c, [key]: value }));
  }, []);

  const replay = useCallback(() => {
    setReplayKey((k) => k + 1);
  }, []);

  const reset = useCallback(() => setConfig(MOTION_DEFAULTS), []);

  return (
    <MotionCtx.Provider value={{ config, update, replay, replayKey, reset }}>
      {children}
    </MotionCtx.Provider>
  );
}

// Fallback hodnota keď nie je Provider (production fallback) — defaultne animuje s baseline values.
export function useMotion() {
  const ctx = useContext(MotionCtx);
  if (!ctx) return { config: MOTION_DEFAULTS, update: () => {}, replay: () => {}, replayKey: 0, reset: () => {} };
  return ctx;
}
